import "./BigPanel.css";

function BigPanel({ title, children }) {
  return (
    <section className="big-panel-container fade-in-up">
      <div className="big-panel-inner hover-lift">
        <h1 className="big-panel-title">{title}</h1>
        <div className="big-panel-content">
          {children}
        </div>
      </div>
    </section>
  );
}

export default BigPanel;
